(function () {
  if (customElements.get('read-more')) return;

  class ReadMore extends HTMLElement {
    connectedCallback() {
      this.textEl = this.querySelector('[data-desc-text]');
      this.toggle = this.querySelector('[data-desc-toggle]');
      if (!this.textEl || !this.toggle) return;

      this.moreLabel = this.toggle.dataset.more || 'Mehr erfahren';
      this.lessLabel = this.toggle.dataset.less || 'Weniger anzeigen';

      this.toggle.addEventListener('click', () => this.toggleExpand());
      this.onResize = () => {
        if (!this.classList.contains('is-expanded')) this.checkOverflow();
      };
      window.addEventListener('resize', this.onResize);

      requestAnimationFrame(() => this.checkOverflow());
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
    }

    checkOverflow() {
      const overflows = this.textEl.scrollHeight - this.textEl.clientHeight > 2;
      this.toggle.hidden = !overflows;
      this.classList.toggle('has-toggle', overflows);
    }

    toggleExpand() {
      const expanded = this.classList.toggle('is-expanded');
      this.toggle.textContent = expanded ? this.lessLabel : this.moreLabel;
    }
  }

  customElements.define('read-more', ReadMore);
})();


/* „Mehr erfahren" in der Kurzbeschreibung: zum Zielbereich springen und ihn öffnen */
document.addEventListener('click', function (event) {
  var trigger = event.target.closest('[data-desc-jump]');
  if (!trigger) return;

  var selector = trigger.getAttribute('data-desc-jump');
  if (!selector) return;

  var target;
  try {
    target = document.querySelector(selector);
  } catch (error) {
    return;
  }
  if (!target) return;

  event.preventDefault();

  var details = target.matches('details') ? target : target.querySelector('details');
  if (details) details.open = true;

  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
});


/* Buybox-Akkordions: es bleibt immer nur eines offen */
document.addEventListener('toggle', function (event) {
  var details = event.target;
  if (!details.matches || !details.matches('details.product__accordion') || !details.open) return;

  var scope = details.closest('.main-product__info') || document;
  scope.querySelectorAll('details.product__accordion[open]').forEach(function (other) {
    if (other !== details) other.open = false;
  });
}, true);


/* Bewertungs-Slider: Striche, Pfeile, weicher automatischer Wechsel */
(function () {
  function karten(track) {
    return [].slice.call(track.querySelectorAll('.product__review'));
  }

  function aktiv(track) {
    var k = karten(track);
    if (!k.length) return 0;
    var breite = k[0].getBoundingClientRect().width + 12;
    return Math.min(k.length - 1, Math.max(0, Math.round(track.scrollLeft / breite)));
  }

  // Eigene Animation statt scroll-behavior: dadurch laesst sich die Dauer steuern.
  // Wichtig: scroll-snap muss waehrenddessen aus sein, sonst rastet der Browser
  // sofort am Ziel ein und der Wechsel springt in einem einzigen Frame.
  function gleiteZu(track, ziel, dauer) {
    if (track.__anim) cancelAnimationFrame(track.__anim);
    var start = track.scrollLeft;
    var weg = ziel - start;
    if (!weg) return;

    track.style.scrollSnapType = 'none';
    var t0 = performance.now();

    function fertig() {
      track.__anim = null;
      track.style.scrollSnapType = '';
    }

    function schritt(t) {
      var f = Math.min(1, (t - t0) / dauer);
      var e = f < 0.5 ? 4 * f * f * f : 1 - Math.pow(-2 * f + 2, 3) / 2;
      track.scrollLeft = start + weg * e;
      if (f < 1) {
        track.__anim = requestAnimationFrame(schritt);
      } else {
        fertig();
      }
    }

    track.__anim = requestAnimationFrame(schritt);
  }

  function zeige(track, index, dauer) {
    var k = karten(track);
    if (!k.length) return;
    index = Math.min(k.length - 1, Math.max(0, index));
    var breite = k[0].getBoundingClientRect().width + 12;
    gleiteZu(track, index * breite, dauer);
  }

  function update(track) {
    var wrap = track.closest('.product__reviews');
    if (!wrap) return;
    var i = aktiv(track);
    wrap.querySelectorAll('.product__reviews-dot').forEach(function (dot, n) {
      dot.classList.toggle('is-active', n === i);
    });
    var prev = wrap.querySelector('[data-reviews-prev]');
    var next = wrap.querySelector('[data-reviews-next]');
    if (prev) prev.disabled = i === 0;
    if (next) next.disabled = i >= karten(track).length - 1;
  }

  function init() {
    document.querySelectorAll('[data-reviews-track]').forEach(function (track) {
      if (track.dataset.reviewsReady) return;
      track.dataset.reviewsReady = '1';

      var wrap = track.closest('.product__reviews');
      var dauer = parseInt(track.getAttribute('data-speed'), 10) || 500;
      var sekunden = parseInt(track.getAttribute('data-autoplay'), 10) || 0;
      var timer = null;

      function weiter(richtung) {
        var i = aktiv(track);
        var letzte = karten(track).length - 1;
        var ziel = i + richtung;
        if (ziel > letzte) ziel = 0;
        if (ziel < 0) ziel = letzte;
        zeige(track, ziel, dauer);
      }

      function start() {
        if (!sekunden || timer) return;
        timer = setInterval(function () { weiter(1); }, sekunden * 1000);
      }
      function stopp() {
        if (!timer) return;
        clearInterval(timer);
        timer = null;
      }

      update(track);
      track.addEventListener('scroll', function () { update(track); }, { passive: true });
      window.addEventListener('resize', function () { update(track); });

      if (!wrap) return;

      var prev = wrap.querySelector('[data-reviews-prev]');
      var next = wrap.querySelector('[data-reviews-next]');
      if (prev) prev.addEventListener('click', function () { stopp(); weiter(-1); });
      if (next) next.addEventListener('click', function () { stopp(); weiter(1); });
      wrap.addEventListener('mouseenter', stopp);
      wrap.addEventListener('mouseleave', start);
      wrap.addEventListener('focusin', stopp);
      track.addEventListener('pointerdown', stopp);
      track.addEventListener('touchstart', stopp, { passive: true });

      // Striche: klicken und ziehen
      var leiste = wrap.querySelector('[data-reviews-dots]');
      if (leiste) {
        var zieht = false;

        function ausPosition(x) {
          var r = leiste.getBoundingClientRect();
          var anteil = (x - r.left) / r.width;
          return Math.floor(anteil * karten(track).length);
        }

        leiste.addEventListener('click', function (e) {
          var dot = e.target.closest('[data-reviews-dot]');
          if (!dot) return;
          stopp();
          zeige(track, parseInt(dot.getAttribute('data-reviews-dot'), 10), dauer);
        });

        leiste.addEventListener('pointerdown', function (e) {
          zieht = true;
          stopp();
          leiste.classList.add('is-dragging');
          leiste.setPointerCapture(e.pointerId);
          zeige(track, ausPosition(e.clientX), 160);
        });
        leiste.addEventListener('pointermove', function (e) {
          if (!zieht) return;
          var i = ausPosition(e.clientX);
          if (i !== aktiv(track)) zeige(track, i, 160);
        });
        function endeZiehen(e) {
          if (!zieht) return;
          zieht = false;
          leiste.classList.remove('is-dragging');
          try { leiste.releasePointerCapture(e.pointerId); } catch (err) {}
        }
        leiste.addEventListener('pointerup', endeZiehen);
        leiste.addEventListener('pointercancel', endeZiehen);
        leiste.addEventListener('lostpointercapture', endeZiehen);
        window.addEventListener('pointerup', endeZiehen);
      }

      if (sekunden && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (e) {
          e.forEach(function (x) { x.isIntersecting ? start() : stopp(); });
        }, { threshold: 0.4 }).observe(track);
      } else {
        start();
      }
    });
  }

  function kopfhoehe() {
    var header = document.querySelector('header');
    var sec = header && header.closest('.shopify-section');
    var el = sec || header;
    if (!el) return;
    if (getComputedStyle(el).position !== 'sticky') return;
    document.documentElement.style.setProperty('--header-h', Math.round(el.getBoundingClientRect().height) + 'px');
  }

  function bereit() {
    init();
    kopfhoehe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bereit);
  } else {
    bereit();
  }
  window.addEventListener('resize', kopfhoehe);
  document.addEventListener('shopify:section:load', bereit);
})();


/* Laesst sich ein Bewertungsfoto nicht laden (Google-Links laufen aus),
   wird es entfernt statt als kaputtes Bild angezeigt. */
document.addEventListener('error', function (event) {
  var img = event.target;
  if (!img.matches || !img.matches('.product__review-photo img')) return;
  var knopf = img.closest('.product__review-photo');
  var reihe = knopf && knopf.parentElement;
  if (knopf) knopf.remove();
  if (reihe && !reihe.querySelector('.product__review-photo')) reihe.remove();
}, true);
